function getCSSProperty(node, propertyKey) {
  try {
    return window.getComputedStyle(node).getPropertyValue(propertyKey);
  } catch (e) {
    console.warn(`could not get css property for ${node} due to ${e}`); // eslint-disable-line no-console
  }
}

function getCSSNumericValue(cssValue) {
  try {
    return Number(cssValue.replace(/px|%/, ''));
  } catch (e) {
    console.warn(`could not get numeric css value for ${cssValue} due to ${e}`); // eslint-disable-line no-console
  }
}

function serialize(obj) {
  const str = [];
  for (const p in obj)
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
}

function requiredParam(param) {
  const requiredParamError = new Error(
    `Required parameter, "${param}" is missing.`
  );

  // preserve original stack trace
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(
      requiredParamError,
      requiredParam
    );
  }

  throw requiredParamError;
}

export {
  getCSSProperty,
  getCSSNumericValue,
  serialize,
  requiredParam,
  // deprecated,
};

